import { useState, useEffect, useRef } from 'react'
import { Button, Dropdown, Table } from 'react-bootstrap';
import Api from 'helpers/Api';
import Loader from 'components/misc/Loader';
import moment from 'moment';
import NoDataFound from 'components/misc/NoDataFound';
import Pagination from 'components/misc/Pagination';
import TableHeader from 'components/misc/TableHeader';
import TableCol from 'components/misc/TableCol';
import PriceValue from 'components/partials/PriceValue';
import MenuOptions from 'components/misc/MenuOptions';
import { Navigate, useNavigate } from 'react-router-dom';

function Index(props) {

    const navigate = useNavigate();

    const defaultData = [];

    const tableRef = useRef(null);

    const [state, setState] = useState({
        data: defaultData,
        pages: 0,
        total: 0,
        loading: false,
        filter: {
            page: 1,
        },
        refresh: false,
    });

    useEffect(() => {

        loading(true);

        Api.get('accounts/documents', {
            params: {
                id: props.id,
                ...state.filter,
            }
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: res.data.items,
                total: res.data.total,
                pages: res.data.pages,
                filter: {
                    ...prev.filter,
                    ...res.data.filter,
                },
            }));

            if (res.data.pages > 0 && state.filter.page > res.data.pages) {
                return handlePage({ selected: res.data.pages - 1 });
            }

            loading(false);
            sorting(false);
        });
    }, [props.id, state.refresh]);

    const loading = (loading) => {
        setState(prev => ({
            ...prev,
            loading: Boolean(loading)
        }));
    }

    const sorting = (sorting) => {
        setState(prev => ({
            ...prev,
            sorting: Boolean(sorting)
        }));
    }

    const handlePage = page => {
        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                page: page.selected + 1,
            },
            refresh: new Date()
        }));
    }

    const handleSort = (sort, order) => {
        setState(prev => ({
            ...prev,
            sorting: true,
            filter: {
                ...prev.filter,
                sort: sort,
                order: order,
                page: 1,
            },
            refresh: new Date().getTime()
        }));
    }

    const handleShow = data => {
        props.showDocument(data);
    }

    const handleAdd = () => {

    }

    const handleEdit = data => {
        switch (data.type.code) {
            case 'protocol':
                navigate('/protocols/' + data.id + '/edit');
                break;
            case 'warranty':
                navigate('/warranty/' + data.id + '/edit');
                break;
            case 'contract':
                navigate('/contracts/' + data.id + '/edit');
                break;
            case 'offer':
                navigate('/offers/' + data.id + '/edit');
                break;
        }
    }

    const handleDelete = id => {
        props.deleteDocument(id);
    }

    return (

        state.loading && !state.sorting
            ?
            <Loader />
            :
            state.data.length === 0 ?
                <NoDataFound>
                    <div>
                        Няма намерена информация!
                    </div>
                    {/* <br />
                    <Button variant="outline-dark" onClick={e => handleAdd()}>
                        Нов документ
                    </Button> */}
                </NoDataFound>
                :
                <>
                    <Table className="big" striped ref={tableRef}>
                        <TableHeader
                            tableRef={tableRef}
                            activeSortKey={state.filter.sort}
                            activeSortDir={state.filter.order}
                            onSort={(col, dir) => handleSort(col, dir)}
                        >
                            <TableCol sortable sortKey="id" style={{ width: '5%' }}>ID</TableCol>
                            <TableCol sortable sortKey="type">Тип</TableCol>
                            <TableCol sortable sortKey="document_name">Име</TableCol>
                            <TableCol sortable sortKey="created_at">Създаден</TableCol>
                            <TableCol sortable sortKey="creator">Потребител</TableCol>
                            <TableCol className="text-center" sortable sortKey="status">Статус</TableCol>
                            <TableCol className="options">Опции</TableCol>
                        </TableHeader>
                        <tbody>
                            {state.data.map((r, i) =>
                                <tr key={i}>
                                    <td>
                                        {r.id}
                                    </td>
                                    <td>
                                        {r.type?.name}
                                    </td>
                                    <td>
                                        {r.document_name}
                                    </td>
                                    <td>
                                        {r.created_at ? moment(r.created_at).format('DD.MM.YYYY') : ''}
                                    </td>
                                    <td>
                                        {r.creator?.username}
                                    </td>
                                    <td className={`text-center`} style={{ backgroundColor: r.status?.background }}>
                                        {r.status?.name}
                                    </td>
                                    <td className="options">
                                        <MenuOptions>
                                            <Dropdown.Item onClick={e => handleShow(r)}>
                                                Преглед
                                            </Dropdown.Item>
                                            {r.allow_edit &&
                                                <Dropdown.Item onClick={e => handleEdit(r)}>
                                                    Редакция
                                                </Dropdown.Item>
                                            }
                                            <Dropdown.Item onClick={e => handleDelete(r.id)}>
                                                Разкачване
                                            </Dropdown.Item>
                                        </MenuOptions>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    <Pagination
                        page={state.filter.page}
                        pages={state.pages}
                        handlePage={handlePage}
                    />
                </>
    )
}

export default Index;